<template>
    <div class="sidebar">
        <nav class="d-flex sidebar-nav">

            <div v-if="appType === 'Website'">
                <router-link v-if="model.app.website_id" :to="{ name: 'open-site', params: {appId: appId, id: model.app.website_id}}"
                             class="no-underline">
                    <div class="d-flex align-items-center mx-auto mt-4 border" :class="menuItemClasses('page-editor')">
                        <i class="m-auto fas fa-browser fa-lg" :class="menuIconClasses('page-editor')"></i>
                    </div>
                </router-link>

                <router-link :to="{ name: 'open-app', params: {id: appId}}" class="no-underline">
                    <div class="d-flex align-items-center mx-auto mt-4 border"
                         :class="editorItemClasses()">
                        <i class="m-auto fas fa-table fa-lg" :class="editorIconClasses()"></i>
                    </div>
                </router-link>
            </div>

            <div v-else>
                <router-link :to="{ name: 'open-app', params: {id: appId}}" class="no-underline">
                    <div class="d-flex align-items-center mx-auto mt-4 border"
                         :class="editorItemClasses()">
                        <i class="m-auto fas fa-table fa-lg" :class="editorIconClasses()"></i>
                    </div>
                </router-link>

                <router-link v-if="model.app.website_id" :to="{ name: 'open-site', params: {appId: appId, id: model.app.website_id}}"
                             class="no-underline">
                    <div class="d-flex align-items-center mx-auto mt-4 border" :class="menuItemClasses('page-editor')">
                        <i class="m-auto fas fa-browser fa-lg" :class="menuIconClasses('page-editor')"></i>
                    </div>
                </router-link>

            </div>

            <router-link :to="{ name: 'marketplace', params: {id: appId}}" class="no-underline">
                <div class="d-flex align-items-center mx-auto mt-4 border text-success" :class="menuItemClasses('marketplace')">
                    <i class="m-auto fas fa-store fa-lg" :class="menuIconClasses('marketplace')"></i>
                </div>
            </router-link>

            <router-link :to="{ name: 'collaborators', params: {id: appId}}" class="no-underline">
                <div class="d-flex align-items-center mx-auto mt-4 border" :class="menuItemClasses('collaborators')">
                    <i class="m-auto fas fa-user fa-lg" :class="menuIconClasses('collaborators')"></i>
                </div>
            </router-link>

            <router-link :to="{ name: 'integrations', params: {id: appId}}" class="no-underline">
                <div class="d-flex align-items-center mx-auto mt-4" :class="menuItemClasses('integrations')">
                    <i class="m-auto fas fa-cog fa-lg" :class="menuIconClasses('integrations')"></i>
                </div>
            </router-link>

            <router-link :to="{ name: 'notifications', params: {id: appId}}" class="no-underline">
                <div class="d-flex align-items-center mx-auto mt-4" :class="menuItemClasses('notifications')">
                    <i class="m-auto far fa-paper-plane fa-lg" :class="menuIconClasses('notifications')"></i>
                </div>
            </router-link>

        </nav>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                model: webase.model,
                editorNames: ['app-editor', 'view-editor', 'view-renderer']
            }
        },
        props: ['app'],
        computed: {
            appId() {
                if(this.app) {
                    return this.app.id
                }

                return this.model.app.id
            },
            appType() {
                if(this.app) {
                    return this.app.app_type
                }

                return this.model.app.app_type
            }
        },
        mounted() {
            console.log('Sidebar')
            console.log(this.model.app)
        },
        methods: {
            menuItemClasses(routeName) {
                console.log('menuItemClasses, routeName = ' + routeName + ', this.$route.name = ' + this.$route.name)
                return this.$route.name === routeName ? 'side-menu-item bg-white' : 'side-menu-item-inactive'
            },
            menuIconClasses(routeName) {
                return this.$route.name === routeName ? 'text-primary' : 'inactive-menu-icon'
            },
            editorItemClasses() {
                return this.editorNames.includes(this.$route.name) ? 'side-menu-item bg-white' : 'side-menu-item-inactive'
            },
            editorIconClasses() {
                return this.editorNames.includes(this.$route.name) ? 'text-primary' : 'inactive-menu-icon'
            }

        }
    }
</script>

<style>

</style>
